import { render } from "./InterfaceMenu.vue?vue&type=template&id=071ecc31"
import script from "./InterfaceMenu.vue?vue&type=script&lang=js"
export * from "./InterfaceMenu.vue?vue&type=script&lang=js"

import "./InterfaceMenu.vue?vue&type=style&index=0&id=071ecc31&lang=scss"

import exportComponent from "/tmp/3a52593b-0c57-4976-8665-ec4c8a4d9b76/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__